import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import moment from "moment";

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';

class UnstyledEventDetail extends React.Component {
    render() {
        const sensorStore = this.props.rootStore.sensorStore;
        const event = this.props.event;

        switch (event.kind) {
            case "room_sensor_disabled":
                return (<>
                    <Typography>Sensor <b>{ sensorStore.sensors.get(event.meta.sensor_id).human_name }</b> Disabled</Typography>
                </>);

            case "room_sensor_enabled":
                return (<>
                    <Typography>Sensor <b>{ sensorStore.sensors.get(event.meta.sensor_id).human_name }</b> Enabled</Typography>
                </>);

            default:
                // eslint-disable-next-line no-console
                console.error("Timeline event unrecognized.");
        }

        return <Typography>{ event.kind }</Typography>
    }
}
const EventDetail = withStyles(UnstyledEventDetail.styles)(
    inject(stores => ({
        rootStore: stores.rootStore,
    }))(observer(UnstyledEventDetail))
);

class UnstyledRoomTimeline extends React.Component {
    render() {
        if (!this.props.room.timeline || this.props.room.timeline.event_set.length === 0) {
            return (<>
                <Typography variant="h3">Timeline</Typography>
                <Typography>No events.</Typography>
            </>)
        }

        let timeOrderedEvents = this.props.room.timeline.event_set;
        timeOrderedEvents = timeOrderedEvents.sort((a, b) => (a.timestamp > b.timestamp ? -1 : (a.timestamp < b.timestamp ? 1 : 0)));

        return (<>
            <Typography variant="h3">Timeline</Typography>
            <Timeline>
                { timeOrderedEvents.map((event, i) => (
                    <TimelineItem key={ event.id }>
                        <TimelineOppositeContent>
                            <Typography color="textSecondary">
                                { moment(event.timestamp).format("LL") }
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot />
                            { i !== timeOrderedEvents.length - 1 && <TimelineConnector /> }
                        </TimelineSeparator>
                        <TimelineContent>
                            <EventDetail event={ event } />
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </>)
    }
}

export default withStyles(UnstyledRoomTimeline.styles)(observer(UnstyledRoomTimeline));